import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from './styles.css';
import * as commonColumnStyles from '../common-column-styles.css';

export const HeaderRow: React.FC = () => {
  return (
    <div className={styles['row']}>
      <span className={commonColumnStyles['common-title-col']}>
        <ArticleParagraph2 color="text-primary-disabled">Банки и застройщики</ArticleParagraph2>
      </span>
      <span className={commonColumnStyles['common-rate-col']}>
        <ArticleParagraph2 color="text-primary-disabled">Ставка</ArticleParagraph2>
      </span>
      <span className={commonColumnStyles['common-sum-col']}>
        <ArticleParagraph2 color="text-primary-disabled">Сумма</ArticleParagraph2>
      </span>
      <span className={commonColumnStyles['common-term-col']}>
        <ArticleParagraph2 color="text-primary-disabled">Срок</ArticleParagraph2>
      </span>
      <span className={commonColumnStyles['common-payment-col']}>
        <ArticleParagraph2 color="text-primary-disabled" textAlign="right">
          Ежемесячный платёж
        </ArticleParagraph2>
      </span>
    </div>
  );
};
